<template>
  <!-- Modal -->
  <div class="modal fade" :id="name" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">DeviceID QRCode</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div style="margin-left: auto; margin-right: auto;">
            <qrcode :value="deviceid" :options="{ width: 220 }"></qrcode>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  components: {
    'qrcode':VueQrcode,
  },
  props: {
    name: {
      type: String
    },
    deviceid: {
      type: String
    }
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ShowQRCodeModal.vue?6fdfafca